<div class="dialog-container">
  <ng-container>
    <ng-container *ngIf="currentValidationStatus === verifiedAddressErrorConstants.MISMATCH">
      <h1 id="addressValidationDialog-text-closeMatchFoundHeader">Confirm Address</h1>
      <p id="addressValidationDialog-text-closeMatchFoundMsg">We couldn't find the exact address you entered, but we found a close match.</p>
    </ng-container>

    <ng-container *ngIf="currentValidationStatus === verifiedAddressErrorConstants.NOT_CONFIRMED">
      <h1 id="addressValidationDialog-text-notConfirmedHeader">
        <mat-icon svgIcon="uz-warning-outline" class="warning"></mat-icon>
        Address Not Found
      </h1>
      <p id="addressValidationDialog-text-notConfirmedMsg" class="dialog-message">We could not verify the address as entered. Please double check that the address is correct.</p>
    </ng-container>

    <ng-container
      *ngIf="
        currentValidationStatus === verifiedAddressErrorConstants.NOT_CONFIRMED_IGNORE_SECONDARY ||
        currentValidationStatus === verifiedAddressErrorConstants.NOT_CONFIRMED_MISSING_SECONDARY
      "
    >
      <h1 id="addressValidationDialog-text-missingInfoHeader">
        <mat-icon svgIcon="uz-warning-outline" class="warning"></mat-icon>
        Address Missing Information
      </h1>
      <p id="addressValidationDialog-text-missingInfoMsg" class="dialog-message">
        We could not verify the address as entered. Please double check you entered the apartment, suite, or office number correctly.
      </p>
    </ng-container>

    <mat-radio-group [formControl]="selectedAddressControl">
      <mat-radio-button  id="addressValidationDialog-radio-unverifiedAddress" [value]="data.verifiedAddress.requestedAddress">
        <label class="radio-button-title">
          {{ currentValidationStatus === verifiedAddressErrorConstants.MISMATCH ? 'What you entered' : 'Use as entered' }}
        </label>
        <div class="address-display">
          <p id="addressValidationDialog-text-unverifiedStreetAddress">{{ data.verifiedAddress.requestedAddress.streetAddress1 }}</p>
          <p id="addressValidationDialog-text-unverifiedStreetAddressTwo"*ngIf="data.verifiedAddress.requestedAddress.streetAddress2">
            {{ data.verifiedAddress.requestedAddress.streetAddress2 }}
          </p>
          <p id="addressValidationDialog-text-unverifiedCityStateZip">
            {{ data.verifiedAddress.requestedAddress.city }},
            {{ data.verifiedAddress.requestedAddress.stateCode }}
            {{ data.verifiedAddress.requestedAddress.zipCode }}
          </p>
        </div>
      </mat-radio-button>

      <mat-radio-button id="addressValidationDialog-radio-recommendedAddress"
        *ngIf="currentValidationStatus === verifiedAddressErrorConstants.MISMATCH"
        [value]="data.verifiedAddress.suggestedAddresses[0]"
      >
        <label class="radio-button-title">Recommended</label>
        <div class="address-display">
          <p id="addressValidationDialog-text-recommendedStreetAddress">{{ data.verifiedAddress.suggestedAddresses[0].streetAddress1 }}</p>
          <p id="addressValidationDialog-text-recommendedStreetAddressTwo" *ngIf="data.verifiedAddress.suggestedAddresses[0].streetAddress2">
            {{ data.verifiedAddress.suggestedAddresses[0].streetAddress2 }}
          </p>
          <p id="addressValidationDialog-text-recommendedCityStateZip">
            {{ data.verifiedAddress.suggestedAddresses[0].city }},
            {{ data.verifiedAddress.suggestedAddresses[0].stateCode }}
            {{ data.verifiedAddress.suggestedAddresses[0].zipCode }}
          </p>
        </div>
      </mat-radio-button>
    </mat-radio-group>

    <div mat-dialog-actions align="end" class="action-buttons">
      <button id="addressValidationDialog-button-backToEditing" mat-button type="button" color="primary" (click)="handleBackToEditAddress()">Back to editing</button>
      <button id="addressValidationDialog-button-save" mat-raised-button type="button" color="primary" (click)="handleSubmitAddress()" [disabled]="!confirmedAddress">Save</button>
    </div>
  </ng-container>
</div>
